var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{attrs:{"screenConfig":_vm.setScreenConfig,"rowClick":_vm.rowClickCallBack,"persistenceKey":'survey-template-list',"loadDataGrid":_vm.loaded,"backButtonEnable":true,"backButtonRoute":'/settings/sales'}})
}
var staticRenderFns = []

export { render, staticRenderFns }